import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';

export interface ISetSiteSAMLEnabledParams {
  enable: boolean;
}

export class SetSiteSAMLEnabledRequest extends Request<ISetSiteSAMLEnabledParams, ISiteSAMLConfiguration> {
  constructor(params: ISetSiteSAMLEnabledParams) {
    super('setSiteSAMLEnabled', params);
  }
}
